import { render, staticRenderFns } from "./ArquivoRepetidoDialog.vue?vue&type=template&id=8e44c968"
import script from "./ArquivoRepetidoDialog.vue?vue&type=script&lang=js"
export * from "./ArquivoRepetidoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports